import { DBSchema, openDB } from 'idb'

// 1️⃣ DB içindeki veri yapısını tanımla
interface OfflineDB extends DBSchema {
  tcsoforQueue: {
    key: number
    value: {
      id?: number
      data: unknown
      createdAt: string
    }
  }
}

// 2️⃣ DB'yi başlatacak fonksiyon
export const getOfflineDb = () =>
  openDB<OfflineDB>('tcsofor-offline-db', 1, {
    upgrade(db) {
      // "tcsoforQueue" adında bir tablo varsa oluşturma
      if (!db.objectStoreNames.contains('tcsoforQueue')) {
        db.createObjectStore('tcsoforQueue', {
          keyPath: 'id',
          autoIncrement: true,
        })
      }
    },
  })
